import * as React from 'react';
import styled from 'styled-components';
import { UserAvatar } from '../UserAvatar/UserAvatar';

interface Props {
  avatarSize?: string;
  avatarUrl?: string;
  name?: string;
  text?: React.ReactNode;
  subText?: React.ReactNode;
}

const Info = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 12px;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const UserInfoCardLayout = (props: Props) => {
  const { text, subText, avatarUrl, name, avatarSize = '36px' } = props;

  return (
    <Container className="user-card-general">
      <UserAvatar userName={name} userAvatar={avatarUrl} size={Number.parseInt(avatarSize)} />
      <Info className="info">
        {text}
        {subText}
      </Info>
    </Container>
  );
};
